module.exports = __webpack_public_path__ + "static/sepcons-eea0f78eb9c5c0ec0b70ca50f80f8618.jpg";